import { createMuiTheme } from "@material-ui/core/styles";
import { ReactComponent as LogoChat } from "assets/images/brands/estadao-logo-name.svg";
import { ReactComponent as CloseIcon } from "assets/images/icon/close.svg";
import ConfirmCloseChat from "component/confirmCloseChat";
import Form from "component/form";
import { Wallet } from "config";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "styled-components";
import { Container, GlobalStyle, Header, IconButton } from "./style";
//import GenerateManifest from "./generate_manifest";
const pathname = "estadao_atendimento";
const currWallet = Wallet[pathname];
const theme = createMuiTheme({
  palette: {
    primary: {
      main: currWallet.color.primary,
      tertiary: currWallet.color.tertiary,
      hover: currWallet.color.hover,
    },
    secondary: {
      main: currWallet.color.secondary,
    },
  },
});

function App() {
  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const openPopover = Boolean(anchorEl);

  useEffect(() => {
    window.chtken = currWallet.token;
    document.title = currWallet.name;
  }, [open]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        {open && (
          <Container>
            <Header>
              <LogoChat width="100px" height="100px" />
              <div>
                <IconButton onClick={(event) => setAnchorEl(event.currentTarget)} className="digitalk-close">
                  <CloseIcon />
                </IconButton>
              </div>
            </Header>
            <Form
              pathname={pathname}
              wallet={currWallet}
              handleClose={() => setOpen(false)}
              setAnchorEl={setAnchorEl}
            />
          </Container>
        )}


        <ConfirmCloseChat
          openPopover={openPopover}
          setOpen={setOpen}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
        />

        <ToastContainer
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </ThemeProvider>
    </>
  );
}

export default App;
